import { useState } from 'react';
import type { CanvasChatMessage } from '@/pages/canvas/canvas-types';
import { ChatToolProgressCard } from './ChatToolProgressCard';
import { PlaybookTaskCard } from './PlaybookTaskCard';

/** Tool and playbook events describe the same request. Upgrade its existing
 * card in place, keeping disclosure state local to this message/run. */
export function CanvasRunProgressCard({ message, isActive }: { message: CanvasChatMessage; isActive: boolean }) {
  const [expanded, setExpanded] = useState(false);
  const hasImageGallery = message.imageSlots?.some(slot => !!slot.resolved)
    || (!message.imageSlots?.length && !!message.thumbnails?.length);
  return <div data-testid={`canvas-run-progress-${message.id}`}>
    {message.playbookProgress ? (
      <PlaybookTaskCard progress={message.playbookProgress} messageId={message.id}
        messageImageSlots={message.imageSlots} isActive={isActive}
        showThumbnails={!hasImageGallery}
        expanded={expanded} onExpandedChange={setExpanded} />
    ) : (
      <ChatToolProgressCard groups={message.agentTaskGroups ?? []} isStreaming={isActive}
        expanded={expanded} onExpandedChange={setExpanded} />
    )}
  </div>;
}
